<div class="judet-container">
    <h1 class="solcitare-title">Editare secțiune</h1>
    <form class="judet-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="judet-nume">
            <mat-form-field appearance="fill">
                <mat-label>Nume</mat-label>
                <input type="text" matInput formControlName="name">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="judet-slug">
            <mat-form-field appearance="fill">
                <mat-label>Slug</mat-label>
                <input type="text" matInput formControlName="slug">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="judet-observatii">
            <mat-form-field appearance="fill">
                <mat-label>Observații</mat-label>
                <input type="text" matInput formControlName="observations">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['observations'].valid && form.controls['observations'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
        <div class="judet-action-btns">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">Close</button>
            <button class="buttons" type="submit" mat-flat-button color="primary">Save</button>
        </div>
    </form>
</div>
